"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.unregisterMouseEvents = exports.registerMouseEvents = exports.unregisterPassiveMouseEvents = exports.registerPassiveMouseEvents = exports.emitSyntheticMouseEvent = exports.isSyntheticMouseEvent = void 0;
const types_1 = require("../../types");
const inputModeManager_1 = require("../managers/inputModeManager");
const touch_1 = require("./touch");
const syntheticKey = Symbol('synthetic');
const isSyntheticMouseEvent = (evt) => {
    // TODO: Why does this get triggered twice when checking in an event callback?
    return evt instanceof MouseEvent ? !!evt[syntheticKey] : !!evt.nativeEvent[syntheticKey];
};
exports.isSyntheticMouseEvent = isSyntheticMouseEvent;
const emitSyntheticMouseEvent = (event, target) => {
    const mouseEvent = new MouseEvent(event, {
        bubbles: true,
        cancelable: true,
        view: window,
        detail: 0,
        screenX: undefined,
        screenY: undefined,
        clientX: undefined,
        clientY: undefined,
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: false,
        button: 0,
        buttons: 0,
        relatedTarget: null,
    });
    Object.defineProperty(mouseEvent, syntheticKey, {
        value: true,
        writable: false,
        enumerable: false,
    });
    target.dispatchEvent(mouseEvent);
};
exports.emitSyntheticMouseEvent = emitSyntheticMouseEvent;
const onMouseMove = (evt) => {
    const { sourceCapabilities, webkitForce } = evt;
    // Touch end events trigger subsequent mouse move events. To filter these out
    // we need to check for `firesTouchEvents` on Chrome and `webkitForce` on Safari
    if ((sourceCapabilities === null || sourceCapabilities === void 0 ? void 0 : sourceCapabilities.firesTouchEvents) === false || webkitForce === 0) {
        (0, inputModeManager_1.setInputMode)(types_1.DetailedInputMode.PassiveMouse, false);
    }
};
const onMouseDown = (evt) => {
    if (!(0, exports.isSyntheticMouseEvent)(evt) && !(0, touch_1.wasRecentTouchEnd)()) {
        (0, inputModeManager_1.setInputMode)(types_1.DetailedInputMode.Mouse, false);
    }
};
let passiveMouseEventsRegistered = false;
const registerPassiveMouseEvents = () => {
    if (passiveMouseEventsRegistered) {
        return;
    }
    document.addEventListener('mousemove', onMouseMove, { passive: false });
    passiveMouseEventsRegistered = true;
};
exports.registerPassiveMouseEvents = registerPassiveMouseEvents;
const unregisterPassiveMouseEvents = () => {
    if (!passiveMouseEventsRegistered) {
        return;
    }
    document.removeEventListener('mousemove', onMouseMove);
    passiveMouseEventsRegistered = false;
};
exports.unregisterPassiveMouseEvents = unregisterPassiveMouseEvents;
let mouseEventsRegistered = false;
const registerMouseEvents = () => {
    if (mouseEventsRegistered) {
        return;
    }
    document.addEventListener('mousedown', onMouseDown, { passive: false });
    mouseEventsRegistered = true;
};
exports.registerMouseEvents = registerMouseEvents;
const unregisterMouseEvents = () => {
    if (!mouseEventsRegistered) {
        return;
    }
    document.removeEventListener('mousedown', onMouseDown);
    mouseEventsRegistered = false;
};
exports.unregisterMouseEvents = unregisterMouseEvents;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW91c2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29yZS9mb3VuZGF0aW9uL21vdXNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw0REFBNEQ7OztBQUU1RCx1Q0FBZ0Q7QUFDaEQsbUVBQTREO0FBQzVELG1DQUE0QztBQUU1QyxNQUFNLFlBQVksR0FBRyxNQUFNLENBQUMsV0FBVyxDQUFDLENBQUM7QUFjbEMsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLEdBQXVELEVBQVcsRUFBRTtJQUN0Ryw4RUFBOEU7SUFDOUUsT0FBTyxHQUFHLFlBQVksVUFBVSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLFlBQVksQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLFdBQVcsQ0FBQyxZQUFZLENBQUMsQ0FBQztBQUM3RixDQUFDLENBQUM7QUFIVyxRQUFBLHFCQUFxQix5QkFHaEM7QUFFSyxNQUFNLHVCQUF1QixHQUFHLENBQUMsS0FBYSxFQUFFLE1BQW1CLEVBQUUsRUFBRTtJQUMxRSxNQUFNLFVBQVUsR0FBRyxJQUFJLFVBQVUsQ0FBQyxLQUFLLEVBQUU7UUFDckMsT0FBTyxFQUFFLElBQUk7UUFDYixVQUFVLEVBQUUsSUFBSTtRQUNoQixJQUFJLEVBQUUsTUFBTTtRQUNaLE1BQU0sRUFBRSxDQUFDO1FBQ1QsT0FBTyxFQUFFLFNBQVM7UUFDbEIsT0FBTyxFQUFFLFNBQVM7UUFDbEIsT0FBTyxFQUFFLFNBQVM7UUFDbEIsT0FBTyxFQUFFLFNBQVM7UUFDbEIsT0FBTyxFQUFFLEtBQUs7UUFDZCxNQUFNLEVBQUUsS0FBSztRQUNiLFFBQVEsRUFBRSxLQUFLO1FBQ2YsT0FBTyxFQUFFLEtBQUs7UUFDZCxNQUFNLEVBQUUsQ0FBQztRQUNULE9BQU8sRUFBRSxDQUFDO1FBQ1YsYUFBYSxFQUFFLElBQUk7S0FDdEIsQ0FBQyxDQUFDO0lBRUgsTUFBTSxDQUFDLGNBQWMsQ0FBQyxVQUFVLEVBQUUsWUFBWSxFQUFFO1FBQzVDLEtBQUssRUFBRSxJQUFJO1FBQ1gsUUFBUSxFQUFFLEtBQUs7UUFDZixVQUFVLEVBQUUsS0FBSztLQUNwQixDQUFDLENBQUM7SUFFSCxNQUFNLENBQUMsYUFBYSxDQUFDLFVBQVUsQ0FBQyxDQUFDO0FBQ3JDLENBQUMsQ0FBQztBQTFCVyxRQUFBLHVCQUF1QiwyQkEwQmxDO0FBU0YsTUFBTSxXQUFXLEdBQUcsQ0FBQyxHQUFlLEVBQUUsRUFBRTtJQUNwQyxNQUFNLEVBQUUsa0JBQWtCLEVBQUUsV0FBVyxFQUFFLEdBQUcsR0FBaUMsQ0FBQztJQUM5RSw2RUFBNkU7SUFDN0UsZ0ZBQWdGO0lBQ2hGLElBQUksQ0FBQSxrQkFBa0IsYUFBbEIsa0JBQWtCLHVCQUFsQixrQkFBa0IsQ0FBRSxnQkFBZ0IsTUFBSyxLQUFLLElBQUksV0FBVyxLQUFLLENBQUMsRUFBRSxDQUFDO1FBQ3RFLElBQUEsK0JBQVksRUFBQyx5QkFBaUIsQ0FBQyxZQUFZLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDeEQsQ0FBQztBQUNMLENBQUMsQ0FBQztBQUVGLE1BQU0sV0FBVyxHQUFHLENBQUMsR0FBZSxFQUFFLEVBQUU7SUFDcEMsSUFBSSxDQUFDLElBQUEsNkJBQXFCLEVBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxJQUFBLHlCQUFpQixHQUFFLEVBQUUsQ0FBQztRQUN0RCxJQUFBLCtCQUFZLEVBQUMseUJBQWlCLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2pELENBQUM7QUFDTCxDQUFDLENBQUM7QUFFRixJQUFJLDRCQUE0QixHQUFHLEtBQUssQ0FBQztBQUVsQyxNQUFNLDBCQUEwQixHQUFHLEdBQUcsRUFBRTtJQUMzQyxJQUFJLDRCQUE0QixFQUFFLENBQUM7UUFDL0IsT0FBTztJQUNYLENBQUM7SUFDRCxRQUFRLENBQUMsZ0JBQWdCLENBQUMsV0FBVyxFQUFFLFdBQVcsRUFBRSxFQUFFLE9BQU8sRUFBRSxLQUFLLEVBQUUsQ0FBQyxDQUFDO0lBRXhFLDRCQUE0QixHQUFHLElBQUksQ0FBQztBQUN4QyxDQUFDLENBQUM7QUFQVyxRQUFBLDBCQUEwQiw4QkFPckM7QUFFSyxNQUFNLDRCQUE0QixHQUFHLEdBQUcsRUFBRTtJQUM3QyxJQUFJLENBQUMsNEJBQTRCLEVBQUUsQ0FBQztRQUNoQyxPQUFPO0lBQ1gsQ0FBQztJQUNELFFBQVEsQ0FBQyxtQkFBbUIsQ0FBQyxXQUFXLEVBQUUsV0FBVyxDQUFDLENBQUM7SUFFdkQsNEJBQTRCLEdBQUcsS0FBSyxDQUFDO0FBQ3pDLENBQUMsQ0FBQztBQVBXLFFBQUEsNEJBQTRCLGdDQU92QztBQUVGLElBQUkscUJBQXFCLEdBQUcsS0FBSyxDQUFDO0FBRTNCLE1BQU0sbUJBQW1CLEdBQUcsR0FBRyxFQUFFO0lBQ3BDLElBQUkscUJBQXFCLEVBQUUsQ0FBQztRQUN4QixPQUFPO0lBQ1gsQ0FBQztJQUNELFFBQVEsQ0FBQyxnQkFBZ0IsQ0FBQyxXQUFXLEVBQUUsV0FBVyxFQUFFLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7SUFFeEUscUJBQXFCLEdBQUcsSUFBSSxDQUFDO0FBQ2pDLENBQUMsQ0FBQztBQVBXLFFBQUEsbUJBQW1CLHVCQU85QjtBQUVLLE1BQU0scUJBQXFCLEdBQUcsR0FBRyxFQUFFO0lBQ3RDLElBQUksQ0FBQyxxQkFBcUIsRUFBRSxDQUFDO1FBQ3pCLE9BQU87SUFDWCxDQUFDO0lBQ0QsUUFBUSxDQUFDLG1CQUFtQixDQUFDLFdBQVcsRUFBRSxXQUFXLENBQUMsQ0FBQztJQUV2RCxxQkFBcUIsR0FBRyxLQUFLLENBQUM7QUFDbEMsQ0FBQyxDQUFDO0FBUFcsUUFBQSxxQkFBcUIseUJBT2hDIn0=